import React from 'react';
import styled from 'styled-components';
import { typography } from '../../style/theme';
import { getFontSize } from '../../utils/helpers';
var SiteLinksTitle = styled.p.withConfig({
  displayName: "SiteLinksListContainer__SiteLinksTitle",
  componentId: "sc-4v40co-0"
})(["", ";font-weight:500;"], getFontSize(typography.medium));

var SiteLinksListContainer = function SiteLinksListContainer(_ref) {
  var title = _ref.title,
      children = _ref.children;
  return React.createElement("div", null, React.createElement(SiteLinksTitle, null, title), children);
};

export default SiteLinksListContainer;